import { AdStorageStatus } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export interface IAdStorageApi {
  getAdStorageStatus(): Promise<AdStorageStatus>
}

export class AdStorageApi implements IAdStorageApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async getAdStorageStatus(): Promise<AdStorageStatus> {
    return this.edgeClient.getAdStorage()
  }
}
